<template>
  <q-item
    clickable
    tag="a"
    :to="path"
    @click="
      callBack({
        label: text,
        value: path || value
      })
    "
    :active-class="light ? 'nav-active-item-light' : 'nav-active-item'"
    :class="`nav-item `"
  >
    <q-item-section v-if="icon" avatar>
      <q-icon :name="icon" />
    </q-item-section>
    <q-item-section>
      <q-item-label>{{ text }}</q-item-label>
    </q-item-section>
  </q-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NavigationItem',
  props: {
    children: {
      type: Array,
      default: () => []
    },
    path: {
      type: String
    },
    text: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    light: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    },
    className: { type: String, default: '' },
    callBack: {
      type: Function,
      default: () => {
        return null
      }
    }
  }
})
</script>
